import { render, staticRenderFns } from "./ProductCarouselNewest.vue?vue&type=template&id=71147706"
import script from "./ProductCarouselNewest.vue?vue&type=script&lang=js"
export * from "./ProductCarouselNewest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports